import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import routes from '../../helpers/routes';
import { usePushNotifications } from '../../hooks/usePushNotifications';

const Container = styled.div`
  min-height: 100vh; // Mejor centrado vertical
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 2rem;

  button {
    padding: 1rem 2rem;
    font-size: 2.5rem;
    font-weight: bold;
    font-family: 'Arial', sans-serif;
    color: #333;
    border: none;
    border-radius: 1rem;
    background-color: #f1f1f1;
    cursor: pointer;
    flex-basis: 45%;
    min-width: 150px;
    height: 100px;
    transition: background 0.2s;

    &:hover,
    &:focus {
      background-color: #e1e1e1;
      outline: 2px solid #888;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    button {
      width: 100%;
      min-width: unset;
      margin-bottom: 1rem;
    }
  }
`;

const FactoryHome: React.FC = () => {
  const history = useHistory();
  const { subscribe, isSubscribed, isChecking } = usePushNotifications();

  useEffect(() => {
    if (isChecking) return;
    
    const notified = localStorage.getItem('pushNotificationAsked');
    const permissionGranted = Notification.permission === 'granted';
    
    if ((!isSubscribed || !permissionGranted) && !notified) {
      localStorage.setItem('pushNotificationAsked', 'true');
      toast((t) => (
        <span>
          ¿Desea recibir notificaciones de nuevas órdenes?
          <button
            style={{ marginLeft: '8px', padding: '4px 8px' }}
            onClick={() => {
              console.log('Botón Activar clickeado');
              subscribe();
              toast.dismiss(t.id);
            }}
          >
            Activar
          </button>
        </span>
      ), { duration: 10000 });
    }
  }, [isChecking, isSubscribed]);

  const goToFillingPage = () => {
    history.push(routes.filling.index);
  };

  const goToProductionPage = () => {
    history.push(routes.productions.index);
  };

  const goToDispatchTrayPage = () => {
    history.push(routes.dispatchTray.index);
  }

  return (
    <Container>
      <button onClick={goToDispatchTrayPage}>Despacho</button>
      <button onClick={goToFillingPage}>Llenado</button>
      <button onClick={goToProductionPage}>Producciones</button>
    </Container>
  );
};

export default FactoryHome;